<template>
  <div class="edito" v-html="textContent" />
</template>

<script>
import { default as TooltipMixin } from '../../mixins/tooltip.js';
export default {
  name: 'RichText',
  mixins: [TooltipMixin],
  props: {
    textContent: {
      type: String,
      required: true,
    },
  },
};
</script>
